export var CurrentPhaseId = /*#__PURE__*/function (CurrentPhaseId) {
  CurrentPhaseId[CurrentPhaseId["PERIOD"] = 1] = "PERIOD";
  CurrentPhaseId[CurrentPhaseId["FOLLICULAR"] = 2] = "FOLLICULAR";
  CurrentPhaseId[CurrentPhaseId["OVULATION"] = 3] = "OVULATION";
  CurrentPhaseId[CurrentPhaseId["OVULATION_WAITING"] = 4] = "OVULATION_WAITING";
  CurrentPhaseId[CurrentPhaseId["LUTEAL"] = 5] = "LUTEAL";
  CurrentPhaseId[CurrentPhaseId["RECOVERY"] = 6] = "RECOVERY";
  return CurrentPhaseId;
}(CurrentPhaseId || {});
export var TodayPhaseId = /*#__PURE__*/function (TodayPhaseId) {
  TodayPhaseId[TodayPhaseId["PERIOD_CONFIRMED"] = 1] = "PERIOD_CONFIRMED";
  TodayPhaseId[TodayPhaseId["RED_DAYS_PREDICTED"] = 2] = "RED_DAYS_PREDICTED";
  TodayPhaseId[TodayPhaseId["OVULATION_PREDICTED"] = 3] = "OVULATION_PREDICTED";
  TodayPhaseId[TodayPhaseId["LH_SURGE_CONFIRMED"] = 4] = "LH_SURGE_CONFIRMED";
  TodayPhaseId[TodayPhaseId["OVULATION_WAITING"] = 5] = "OVULATION_WAITING";
  TodayPhaseId[TodayPhaseId["OVULATION_CONFIRMED"] = 6] = "OVULATION_CONFIRMED";
  TodayPhaseId[TodayPhaseId["PERIOD_PREDICTED"] = 7] = "PERIOD_PREDICTED";
  TodayPhaseId[TodayPhaseId["RM_BLEEDING"] = 8] = "RM_BLEEDING";
  TodayPhaseId[TodayPhaseId["RM_TEMPERATURES_HIGH"] = 9] = "RM_TEMPERATURES_HIGH";
  TodayPhaseId[TodayPhaseId["RM_TEMPERATURES_STABLE"] = 10] = "RM_TEMPERATURES_STABLE";
  TodayPhaseId[TodayPhaseId["RM_RECOVERING"] = 11] = "RM_RECOVERING";
  TodayPhaseId[TodayPhaseId["RM_NEW_CYCLE_STARTED"] = 12] = "RM_NEW_CYCLE_STARTED";
  TodayPhaseId[TodayPhaseId["RM_RECOVERED"] = 13] = "RM_RECOVERED";
  TodayPhaseId[TodayPhaseId["MISCARRIAGE_BLEEDING"] = 14] = "MISCARRIAGE_BLEEDING";
  TodayPhaseId[TodayPhaseId["MISCARRIAGE_TEMPERATURES_HIGH"] = 15] = "MISCARRIAGE_TEMPERATURES_HIGH";
  TodayPhaseId[TodayPhaseId["MISCARRIAGE_RECOVERING"] = 16] = "MISCARRIAGE_RECOVERING";
  TodayPhaseId[TodayPhaseId["PPM_BLEEDING"] = 17] = "PPM_BLEEDING";
  TodayPhaseId[TodayPhaseId["PPM_TEMPERATURES_HIGH"] = 18] = "PPM_TEMPERATURES_HIGH";
  TodayPhaseId[TodayPhaseId["PPM_TEMPERATURES_STABLE"] = 19] = "PPM_TEMPERATURES_STABLE";
  TodayPhaseId[TodayPhaseId["PPM_RECOVERING"] = 20] = "PPM_RECOVERING";
  TodayPhaseId[TodayPhaseId["PPM_NEW_CYCLE_STARTED"] = 21] = "PPM_NEW_CYCLE_STARTED";
  TodayPhaseId[TodayPhaseId["PPM_RECOVERED"] = 22] = "PPM_RECOVERED";
  TodayPhaseId[TodayPhaseId["PPM_NO_TEMPS"] = 23] = "PPM_NO_TEMPS";
  TodayPhaseId[TodayPhaseId["PERIOD_ENDING"] = 24] = "PERIOD_ENDING";
  TodayPhaseId[TodayPhaseId["PERIOD_ENDED"] = 25] = "PERIOD_ENDED";
  TodayPhaseId[TodayPhaseId["LH_TEST_RECOMMENDED"] = 26] = "LH_TEST_RECOMMENDED";
  TodayPhaseId[TodayPhaseId["LUTEAL_PHASE_ONGOING"] = 27] = "LUTEAL_PHASE_ONGOING";
  return TodayPhaseId;
}(TodayPhaseId || {});